module.exports = __webpack_public_path__ + "static/project-9a-9443c16388dd73ae114abca2f66ad120.png";